import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';

import { AvailableCalendar } from 'tmt-ui-kit';

const AvailableDaysContainer = styled.div`
  @media (min-width: 1200px) {
    display: none;
  }
  box-sizing: content-box;
  padding-top: 16px;
  padding-bottom: 8px;
  height: 36px;
  user-select: none;
`;

const AvailableDays = props => {
  const { tripDetail } = props;
  const availabilities = tripDetail.availabilities
    .filter(a => !a.is_today && !a.is_tomorrow)
    .slice(0, 5);
  if (availabilities.length <= 0) return null;
  return (
    <AvailableDaysContainer>
      {availabilities
        .map(availability => {
          const day = moment(availability.date).format('D');
          const month = moment(availability.date).format('MMM').toUpperCase();
          return (
            <AvailableCalendar
              key={`${day}-${month}`}
              month={month}
              day={day}
              available={availability.status === 'available'}
              onClick={() => {
                if (typeof window !== 'undefined') {
                  window.location.href = `/booking/new?trip=${tripDetail.slug}&date=${moment(`${day}-${month}`, 'DD-MMM').format('DD-MM-YYYY')}&requestType=book&device=availableDays`;
                }
              }}
            />
          );
        })
      }
    </AvailableDaysContainer>
  );
};

AvailableDays.propTypes = {
  tripDetail: PropTypes.object
};

export default AvailableDays;
